export function slowCopy<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
}
